// StyledInput.js
import styled from "styled-components";

import React, { useContext } from "react";

import { FormBuilderContext } from "../context/context";
const StyledInputBase = styled.input`
  outline: none;
  height: ${({ styling }) => `${styling.inputHeight}px`};
  width: ${({ styling }) => `${styling.inputWidth}${styling.inputWidthUnits}`};
  border-width: ${({ styling }) => `${styling.inputBorderWidth}px`};
  border-style: ${({ styling }) => `${styling.inputBorderStyleCheckbox}`};
  border-color: ${({ styling }) => styling.inputBorderColor};
  border-bottom: ${({ styling }) => `solid ${styling.inputBorderColor} ${styling.inputBorderWidth}px`};
  padding: 0 ${({ styling }) => `${styling.inputPaddingInline}px`};
  font-size: ${({ styling }) => `${styling.inputFontSize}px`};
  font-weight: ${({ styling }) => styling.inputFontWeight};
  font-family: ${({ styling }) => styling.inputFontFamily};
  border-radius: ${({ styling }) => `${styling.inputBorderRadius}px`};
  transition: ${(props) => props.theme.transitionMain};

  color: ${({ styling }) => styling.inputColor};
  background-color: ${({ styling }) => styling.inputBackgroundColor};

  &:hover {
    color: ${({ styling }) => styling.inputHoverColor};
    border-color: ${({ styling }) => styling.inputHoverBorderColor};
    background-color: ${({ styling }) => styling.inputHoverBackgroundColor};
  }

  &::placeholder {
    color: ${({ styling }) => styling.placeholderColor};
    font-size: ${({ styling }) => `${styling.placeholderFontSize}px`};
    font-weight: ${({ styling }) => styling.placeholderFontWeight};
    font-family: ${({ styling }) => styling.placeholderFontFamily};
  }

  &:hover::placeholder {
    color: ${({ styling }) => styling.placeholderHoverColor};
  }
`;

const StyledInput = (props) => {
  const { state } = useContext(FormBuilderContext);
  const placeholderText = state.addPlaceholders ? "Example Text" : "";

  return <StyledInputBase {...props} placeholder={placeholderText} />;
};



export default StyledInput;
